import { compose } from '@prophecy/utils/redux';
import { useMemo } from 'react';
import { createStore } from 'redux';

import { initialState, reducer } from './reducer';

export function useDQIDEStore() {
  const store = useMemo(() => {
    // @ts-ignore
    const store = createStore(reducer, { ...initialState }, compose('Observation'));
    return store;
  }, []);
  return store;
}
